var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormFieldsContainer",
    [
      _c(
        "v-flex",
        { attrs: { md3: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "numeric",
                expression: "'numeric'"
              }
            ],
            attrs: {
              label: _vm.formFields.minimoDiasDetencion.label,
              "error-messages": _vm.errors.collect("numSim"),
              "data-vv-name": "numSim",
              disabled: _vm.accion === 3
            },
            model: {
              value: _vm.formFields.minimoDiasDetencion.value,
              callback: function($$v) {
                _vm.$set(_vm.formFields.minimoDiasDetencion, "value", $$v)
              },
              expression: "formFields.minimoDiasDetencion.value"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { md2: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: !false && "required",
                expression: "!false && 'required'"
              }
            ],
            attrs: {
              label: _vm.formFields.minimoTiempo.label,
              "error-messages": _vm.errors.collect("minimoTiempo"),
              id: _vm.formFields.minimoTiempo.id,
              disabled: _vm.accion === 3,
              type: "time"
            },
            model: {
              value: _vm.formFields.minimoTiempo.value,
              callback: function($$v) {
                _vm.$set(_vm.formFields.minimoTiempo, "value", $$v)
              },
              expression: "formFields.minimoTiempo.value"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }